module.exports = __webpack_public_path__ + "img/es-ga.35bd1f9a.svg";